import { useMemo, useCallback } from 'react';
import { pick } from 'js/utils/ramda.util';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as actions from '../store/actions';
import { useDynamicReducerSelector, useDynamicReducerDispatch } from '../store';

export const useLoadMore = () => {
    const translate = useComponentTranslations();
    const dispatch = useDynamicReducerDispatch();
    const {
        page: { nextPageId }, isSummaryLoading, isHistoryLoading,
        isExportLoading, isPreventFetchByAnotherPeriod
    } = useDynamicReducerSelector(pick([
        'page', 'isSummaryLoading', 'isHistoryLoading',
        'isExportLoading', 'isPreventFetchByAnotherPeriod'
    ]));
    const useGetNextPage = useCallback(() => dispatch(actions.loadNextPage()), [dispatch]);

    return useMemo(() => nextPageId
        ? {
            title: translate('loadMore'),
            onClick: useGetNextPage,
            disabled: isSummaryLoading || isHistoryLoading || isExportLoading || isPreventFetchByAnotherPeriod
        }
        : null, [
            translate, useGetNextPage, isHistoryLoading, nextPageId,
            isExportLoading, isSummaryLoading, isPreventFetchByAnotherPeriod
        ]
    );
};
